/**
 * src/modules/dashboard/componentes/companyindicators.js
 * -----------------------------------------------------------------------------
 * Componente público para exibição de indicadores por empresa.
 * - Recebe dados por props.
 * - Exibe filtros aplicados no topo (igual ao FeedbackLojas).
 * - Usa GraficoHeatmapProduto para renderizar os gráficos.
 */

import React from 'react';
import './assuntoempresas.scss';
import { GraficoHeatmapProduto } from '../../../components/graficos/heatmapproduto';

function HeatmapBox({
  categoriaId,
  descricaoCategoria,
  listaDeIndicadoresLojas,
  semdadosparaexibir
}) {
  return (
    <div
      id={`graficos-chart-box-${categoriaId}`}
      className="box-indicadores-graficos box-content heatmap-wrap"
    >
      <div className="graficos-chart-box-action-title">
        <h3>{descricaoCategoria}</h3>
      </div>

      <GraficoHeatmapProduto
        id={categoriaId}
        grafico={listaDeIndicadoresLojas || []}
        semdadosparaexibir={semdadosparaexibir}
        hint={true}
        customHint={true}
        tag={{ lista: 'listaDeLojasIndicador', descricao: 'descricaoIndicador' }}
      />
    </div>
  );
}

export default function AssuntoEmpresas({
  title,
  escopo,
  items = [],
  nls = {},          // ← nls global (para "filtrosAplicados")
  componentNls = {}, // ← nls do tópico (para "semdadosparaexibir", etc.)
  autor,
  filtros = [],       // ← filtros aplicados
  totaldata
}) {
  const t = {
    semdadosparaexibir: componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'Sem dados para exibir',
    periodo: componentNls?.periodo || nls?.periodo || 'Período'
  };

  return (
    <>
    <section className="box-indicadores box-content-like">
      {/* ✅ BLOCO DE FILTROS APLICADOS — IDÊNTICO AO FEEDBACK LOJAS */}
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Conteúdo principal */}
      {items.length === 0 ? (
        <div className="companyind-empty">{t.semdadosparaexibir}</div>
      ) : (
        items.map((g) => (
          <HeatmapBox
            key={g.categoriaId}
            categoriaId={g.categoriaId}
            descricaoCategoria={g.descricaoCategoria}
            listaDeIndicadoresLojas={g.listaDeIndicadoresLojas}
            semdadosparaexibir={t.semdadosparaexibir}
          />
        ))
      )}
    </section>
    {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}


/*
JSON INPUT:

{
      "nls": {
      "semdadosparaexibir": "No data"
      },
      "label": "Principais assuntos",
      "scope": {
        "periodo": {
          "fim": "2025-08-31",
          "ini": "2025-08-01"
        },
        "projetoId": 24,
        "sobreAssunto": "empresas"
      },
      "params": {
        
        "idiomaId": 1,
        "categoriaId": 1    //NÃO É OBRIGATÓRIO, BASTA OMITIR
      },
      "Filtros": [
        {
          "nomedofiltro": "Assunto",
          "valordofiltro": "empresas"
        },
        {
          "nomedofiltro": "Categoria",
          "valordofiltro": "Preço"
        }
         
      ],
      "ordinal": 4,
      "topicKey": "assuntoempresas"
    }




*/